module.exports = {"id":"204977","name":"Iván Piris","rating":"75","photo":"./data/images/photos/0/204977.png","club":{"name":"León","logo":"./data/images/clubs/Leon.png"},"positions":["DD","DG","DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IvanPiris0.json
// module id = 1847
// module chunks = 0